import React__default, { memo } from 'react';
import { Icon } from '@grandvisionhq/icons';

const ErrorMessage = ({ error , id , errorMessage  })=>{
    return error && !!errorMessage ? /*#__PURE__*/ React__default.createElement("div", {
        id: id,
        className: "error-message__error"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        className: "error-message__icon",
        key: "alert-circle",
        name: "alert-circle",
        height: 16,
        width: 16
    }), errorMessage) : null;
};
var ErrorMessage$1 = /*#__PURE__*/ memo(ErrorMessage);

export { ErrorMessage$1 as default };
//# sourceMappingURL=ErrorMessage.js.map
